import { z } from "zod";

export const PageInfo = z.object({
  hasPreviousPage: z.boolean(),
  hasNextPage: z.boolean(),
  startCursor: z.string().nullish(),
  endCursor: z.string().nullish(),
});

export type PageInfo = z.infer<typeof PageInfo>;
